import { SimpleAddLiquidity } from './actions/SimpleAddLiquidity';
import { SimpleAddLiquidityTo } from './actions/SimpleAddLiquidityTo';
import { SwapNoSlippageProtection } from './actions/SwapNoSlippageProtection';
import { SwapToNoSlippageProtection } from './actions/SwapToNoSlippageProtection';
import { SimulateSwap } from './getters/SimulateSwap';
var actions = {
    SwapToNoSlippageProtection: SwapToNoSlippageProtection,
    SwapNoSlippageProtection: SwapNoSlippageProtection,
    SimpleAddLiquidity: SimpleAddLiquidity,
    SimpleAddLiquidityTo: SimpleAddLiquidityTo,
};
var getters = {
    SimulateSwap: SimulateSwap,
};
var FCT_UNISWAP = {
    actions: actions,
    getters: getters,
};
export { FCT_UNISWAP };
